import { Box, CircularProgress, Typography } from '@mui/material';
import React, { ReactText } from 'react';
import { LoadingBox } from 'new/components/Page';
import PageMessageTemplate from 'new/components/PageMessageTemplate';
import Button from 'new/components/Button/Button';

type Props<T> = {
  isLoading: boolean;
  children: ((data: T) => React.ReactNode) | React.ReactNode;
  data?: T;
  loaderHeight?: ReactText;
  loaderWidth?: ReactText;
  onRetry?: () => void;
};

const DataView = <T,>({
  isLoading,
  data,
  children,
  loaderHeight,
  loaderWidth,
  onRetry,
}: Props<T>) => {
  if (isLoading) {
    return (
      <LoadingBox sx={{ height: loaderHeight, width: loaderWidth }}>
        <CircularProgress />
      </LoadingBox>
    );
  } else if (!isLoading && !data) {
    return (
      <PageMessageTemplate
        message={
          <Box display="flex" flexDirection="column" alignItems="center">
            <Typography
              fontSize="1.375rem"
              textAlign="center"
              fontWeight={700}
              marginBottom={2}
            >
              OOPS, SOMETHING WENT WRONG
              <br /> Please verify success or try again.
            </Typography>
            <Button
              color="primary"
              variant="contained"
              onClick={() => onRetry?.()}
            >
              RELOAD DATA
            </Button>
          </Box>
        }
        variant="error"
        hasFullPageLayout
        sx={{ height: '100%' }}
      />
    );
  } else {
    return typeof children === 'function' && !!data ? children(data) : children;
  }
};

export default DataView;
